import { loadSettingsFromPageUrl } from './load-settings-from-current-page'
import { loadSettingsFromScriptUrl } from './load-settings-from-current-script'
import { loadSettingsFromJson } from './load-settings-from-json'
import { loadSettingsFromLocalStorage } from './load-settings-from-local-storage'
import { loadSettingsFromDomain } from './load-settings-from-domain'
import { loadSettingsFromConfig } from './load-settings-from-config-id'
import { type ServiceEnvironment } from './get-url'

export interface LoadSettingsRequirement {
  byDomain?: boolean
  byJsonElement?: string
  byLocalStorage?: boolean | string
  env?: ServiceEnvironment
}

export async function loadSettings<T extends LoadSettingsRequirement> (settings?: T): Promise<T> {
  // Note: loading settings from the script url must be done before any async processing happens
  // otherwise, there is no guarantee that document.currentScript will be available
  settings = loadSettingsFromScriptUrl<T>(settings)
  settings = await loadSettingsFromDomain<T>(settings)
  settings = await loadSettingsFromConfig<T>(settings)
  settings = loadSettingsFromJson<T>(settings)
  settings = loadSettingsFromPageUrl<T>(settings)
  settings = loadSettingsFromLocalStorage<T>(settings)
  return settings
}

export {
  loadSettingsFromPageUrl,
  loadSettingsFromScriptUrl,
  loadSettingsFromJson,
  loadSettingsFromLocalStorage,
  loadSettingsFromDomain,
  loadSettingsFromConfig
}
